module.exports = __webpack_public_path__ + "img/bb_g3_ears-05.b1ca6a05.svg";